const zertifikate = [
  {
    icon: 'ri-award-line',
    title: 'Zahnmedizinische Prophylaxe-Assistentin (ZMP)',
    issuer: 'Landeszahnärztekammer Nordrhein',
    year: '2007',
    description: 'Staatlich anerkannte Fachausbildung mit Schwerpunkt Prophylaxe, Patientenberatung und professionelle Zahnreinigung.',
    color: 'rose',
  },
  {
    icon: 'ri-shield-star-line',
    title: 'PAP-Technologie Zertifizierung',
    issuer: 'Europäisches Kosmetikinstitut',
    year: '2023',
    description: 'Zertifizierte Anwenderin der modernen PAP-Aufhellungstechnologie (Phthalimidoperoxycaproic Acid) – peroxidfrei und EU-konform.',
    color: 'rose',
  },
  {
    icon: 'ri-file-check-line',
    title: 'EU-Kosmetikverordnung (EG) Nr. 1223/2009',
    issuer: 'Europäische Union',
    year: 'Laufend',
    description: 'Alle verwendeten Produkte und Verfahren entsprechen der aktuellen europäischen Kosmetikverordnung und werden regelmäßig geprüft.',
    color: 'rose',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Erste Hilfe & Hygieneschulung',
    issuer: 'DRK Köln',
    year: '2025',
    description: 'Aktuelle Erste-Hilfe-Zertifizierung sowie Hygieneschulung nach RKI-Richtlinien für kosmetische Studios.',
    color: 'rose',
  },
  {
    icon: 'ri-microscope-line',
    title: 'Fortbildung: Digitale Dentaldiagnostik',
    issuer: 'SynMedico GmbH',
    year: '2020–2023',
    description: 'Mehrjährige Weiterbildung in digitaler Dentaldiagnostik, Praxismanagement und modernen Behandlungstechnologien.',
    color: 'rose',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Kund*innenzufriedenheit & Beratungskompetenz',
    issuer: 'IHK Köln',
    year: '2022',
    description: 'Zertifizierte Weiterbildung in professioneller Kund*innenberatung, Kommunikation und Servicequalität im Gesundheitsbereich.',
    color: 'rose',
  },
];

const ausbildung = [
  {
    degree: 'Zahnmedizinische Fachangestellte (ZFA)',
    institution: 'Zahnarztpraxis Köln',
    period: '2005 – 2007',
    description: 'Grundausbildung in der Zahnarztpraxis mit Schwerpunkt Assistenz, Hygiene und Betreuung.',
  },
  {
    degree: 'Zahnmedizinische Prophylaxe-Assistentin (ZMP)',
    institution: 'Landeszahnärztekammer Nordrhein',
    period: '2007',
    description: 'Aufbauqualifikation mit staatlichem Abschluss – Spezialisierung auf Beratung und Betreuung im Dentalbereich.',
  },
  {
    degree: 'Praxismanagement & Digitalisierung',
    institution: 'SynMedico GmbH, Köln',
    period: '2020 – 2023',
    description: 'Berufliche Weiterentwicklung im Bereich digitale Dentalpraxis, Technologieimplementierung und Kund*innenkommunikation.',
  },
];

export default function Zertifikate() {
  return (
    <section className="bg-offwhite py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">

        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Qualifikationen
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            Zertifikate &amp; Ausbildung
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-lg mx-auto leading-relaxed">
            Meine Expertise basiert auf fundierter Ausbildung, kontinuierlicher Weiterbildung und über 19 Jahren praktischer Erfahrung.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">

          {/* Left: Ausbildung timeline */}
          <div className="lg:col-span-2">
            <h3 className="font-sans text-xs font-semibold uppercase tracking-widest text-charcoal/50 mb-6">
              Ausbildungsweg
            </h3>
            <div className="relative pl-6">
              <div className="absolute left-2 top-1 bottom-1 w-0.5 bg-rose/25" />
              <div className="flex flex-col gap-7">
                {ausbildung.map((a, i) => (
                  <div key={i} className="relative">
                    <div className="absolute -left-6 top-1.5 w-4 h-4 rounded-full bg-rose ring-4 ring-offwhite" />
                    <div className="bg-white rounded-xl p-5 ring-1 ring-charcoal/8">
                      <div className="flex items-start justify-between gap-2 mb-1.5">
                        <p className="font-sans text-sm font-semibold text-charcoal leading-snug">{a.degree}</p>
                        <span className="font-sans text-xs text-rose font-medium whitespace-nowrap">{a.period}</span>
                      </div>
                      <p className="font-sans text-xs text-charcoal/50 mb-2">{a.institution}</p>
                      <p className="font-sans text-xs text-charcoal/65 leading-relaxed">{a.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Zertifikate grid */}
          <div className="lg:col-span-3">
            <h3 className="font-sans text-xs font-semibold uppercase tracking-widest text-charcoal/50 mb-6">
              Zertifikate &amp; Qualifikationen
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {zertifikate.map((z, i) => (
                <div
                  key={i}
                  className="bg-white rounded-xl p-5 ring-1 ring-charcoal/8 hover:ring-rose/40 transition-all duration-200 flex flex-col gap-3"
                  itemScope
                  itemType="https://schema.org/EducationalOccupationalCredential"
                >
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-rose/10 rounded-xl flex-shrink-0">
                      <i className={`${z.icon} text-rose text-lg`} />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p
                        className="font-sans text-sm font-semibold text-charcoal leading-snug mb-0.5"
                        itemProp="name"
                      >
                        {z.title}
                      </p>
                      <div className="flex items-center gap-2 flex-wrap">
                        <span
                          className="font-sans text-xs text-charcoal/45"
                          itemProp="recognizedBy"
                        >
                          {z.issuer}
                        </span>
                        <span className="w-1 h-1 rounded-full bg-charcoal/20" />
                        <span className="font-sans text-xs font-medium text-rose">{z.year}</span>
                      </div>
                    </div>
                  </div>
                  <p className="font-sans text-xs text-charcoal/60 leading-relaxed">{z.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom trust bar */}
        <div className="mt-14 bg-charcoal rounded-2xl px-8 py-7 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center bg-rose/20 rounded-xl flex-shrink-0">
              <i className="ri-verified-badge-line text-rose text-2xl" />
            </div>
            <div>
              <p className="font-sans text-sm font-semibold text-white">Vollständig zertifiziert &amp; EU-konform</p>
              <p className="font-sans text-xs text-white/55 leading-relaxed">Alle Behandlungen entsprechen den aktuellen europäischen Sicherheitsstandards.</p>
            </div>
          </div>
          <div className="flex items-center gap-6 flex-shrink-0">
            {[
              { value: '19+', label: 'Jahre Erfahrung' },
              { value: '6', label: 'Zertifikate' },
              { value: '100%', label: 'EU-konform' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <p className="font-serif text-2xl font-medium text-rose">{s.value}</p>
                <p className="font-sans text-xs text-white/50">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
